import { type Components, type Theme } from "@mui/material/styles";

export const muiButtonBaseOverrides: Components<Theme> = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
};
